/**
 * useFAQ Hook
 * FSD: features/support/hooks
 *
 * FAQ 데이터 조회 및 상태 관리
 */

import { useQuery } from "@tanstack/react-query";
import { fetchFAQList } from "@/entities/faq";
import type { FAQListParams } from "@/entities/faq";

const FAQ_QUERY_KEY = ["faq"];

export const useFAQ = (params?: FAQListParams) => {
  const { data, isLoading, error, isError, refetch } = useQuery({
    queryKey: [...FAQ_QUERY_KEY, params],
    queryFn: () => fetchFAQList(params),
    staleTime: 1000 * 60 * 5, // 5분
    gcTime: 1000 * 60 * 10, // 10분
  });

  return {
    faqList: data?.data || [],
    total: data?.data?.length || 0,
    isLoading,
    error: error?.message || (isError ? "FAQ 조회 실패" : null),
    refetch,
  };
};

export default useFAQ;
